import { useState } from "react";
import { useFeatureFlagEnabled } from "@posthog/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useSession } from "@/hooks/use-session";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SignupFormEditor } from "@/components/signup-forms/SignupFormEditor";
import { SubmissionsTable } from "@/components/signup-forms/SubmissionsTable";

export const Route = createFileRoute("/_app/_/forms/$formId")({
	component: EditFormPage,
});

function EditFormPage() {
	const { formId } = Route.useParams();
	const session = useSession();
	const navigate = useNavigate();
	const campaignId = session.campaign?.id;
	const flagEnabled = useFeatureFlagEnabled("signup-forms");
	const [activeTab, setActiveTab] = useState("editor");
	const numericFormId = Number.parseInt(formId, 10);

	useEffect(() => {
		if (flagEnabled === false) {
			navigate({ to: "/", search: {} as never });
		}
	}, [flagEnabled, navigate]);

	if (flagEnabled !== true) return null;

	if (!campaignId) {
		return (
			<div className="p-6 text-muted-foreground">
				No campaign selected.
			</div>
		);
	}

	if (Number.isNaN(numericFormId)) {
		return (
			<div className="p-6 text-muted-foreground">Invalid form ID.</div>
		);
	}

	return (
		<div className="p-6">
			<Tabs value={activeTab} onValueChange={setActiveTab}>
				<TabsList className="mb-6">
					<TabsTrigger value="editor">Editor</TabsTrigger>
					<TabsTrigger value="submissions">Submissions</TabsTrigger>
				</TabsList>

				<TabsContent value="editor">
					<SignupFormEditor
						campaignId={campaignId}
						formId={numericFormId}
					/>
				</TabsContent>

				<TabsContent value="submissions">
					<SubmissionsTable
						campaignId={campaignId}
						formId={numericFormId}
					/>
				</TabsContent>
			</Tabs>
		</div>
	);
}
